/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-01 18:36:21
 */
import request from "@/utils/request";
const index = {
  // 详情
  detail(query) {
    return request({
      url: "/config/detail",
      method: "get",
      params: query
    });
  },
  // 修改
  edit(data) {
    return request({
      url: "/config/edit",
      method: "post",
      data
    });
  },
};
export default index;